import React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import client from '@api/graphql';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';
import Applications from './applications';

const Profile = () => {
  const match = useRouteMatch();

  return (
    <ApolloProvider client={client}>
      <Switch>
        <Route path={`${match.path}/applications`} component={Applications} />
      </Switch>
    </ApolloProvider>
  );
};

export default Profile;
